import React from "react";

const fmtEur = (n) => `${Number(n || 0).toFixed(2).replace(".", ",")} €`;

/**
 * Uniform financial summary used on every admin page that displays revenue.
 * Renders three side-by-side figures: Attendu, Encaissé, Reste dû.
 * Backend source of truth: `admin/stats` (global) and each order's `quote.total` / `totalPaid`.
 */
const FinancialSummary = ({ attendu = 0, encaisse = 0, reste, label, dense = false, testid = "financial-summary" }) => {
  const _reste = reste != null ? reste : Math.max(0, Number(attendu || 0) - Number(encaisse || 0));
  const size = dense ? "text-xl" : "text-2xl sm:text-3xl";
  return (
    <div data-testid={testid} className="grid grid-cols-3 gap-3">
      <div className="bg-white rounded-2xl p-4 shadow-sm border-l-4 border-stone-300">
        <div className="text-[11px] uppercase tracking-widest text-stone-500">CA attendu{label ? ` · ${label}` : ""}</div>
        <div className={`font-serif-display ${size} text-stone-800 mt-1`} data-testid={`${testid}-attendu`}>{fmtEur(attendu)}</div>
      </div>
      <div className="bg-white rounded-2xl p-4 shadow-sm border-l-4 border-emerald-500">
        <div className="text-[11px] uppercase tracking-widest text-stone-500">Encaissé</div>
        <div className={`font-serif-display ${size} text-emerald-700 mt-1`} data-testid={`${testid}-encaisse`}>{fmtEur(encaisse)}</div>
      </div>
      <div className="bg-white rounded-2xl p-4 shadow-sm border-l-4 border-amber-400">
        <div className="text-[11px] uppercase tracking-widest text-stone-500">Reste dû</div>
        <div className={`font-serif-display ${size} text-amber-700 mt-1`} data-testid={`${testid}-reste`}>{fmtEur(_reste)}</div>
      </div>
    </div>
  );
};

export default FinancialSummary;
export { fmtEur };
